export function useTracking() {
    return {
        event: function (category, action, name, value) {
            var _a;
            (_a = window._paq) === null || _a === void 0 ? void 0 : _a.push(["trackEvent", category, action, name, value]);
            return true;
        },
    };
}
